// src/utils/fcmToken.js
import { loadMessaging } from './firebase';

// Notification.requestPermission() only resolves once the user responds to the
// browser's permission prompt — if they never notice/dismiss it, this hangs forever
// with no error. Push notifications are optional; login must not wait on them
// indefinitely, so give the whole flow a hard timeout and fall back to no token.
const withTimeout = (promise, ms) =>
  Promise.race([
    promise,
    new Promise((resolve) => setTimeout(() => resolve(null), ms)),
  ]);

export const getFcmToken = async () => {
  try {
    if (typeof Notification === 'undefined') return null;
    return await withTimeout(_getFcmToken(), 8000);
  } catch (error) {
    console.error('FCM token error:', error);
    return null;
  }
};

const _getFcmToken = async () => {
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return null;

  const fb = await loadMessaging();
  if (!fb) return null;

  const token = await fb.getToken(fb.messaging, {
    vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
  });
  return token || null;
};
